interface HelpCaptionProps {
  children: React.ReactNode;
}

export const HelpCaption: React.FC<HelpCaptionProps> = ({ children }) => {
  return <span className="font-weight-600 font-size-18 py-24">{children}</span>;
};
